export default __webpack_public_path__ + "static/media/gallery_00.62e78e30.jpg";